import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "48d42c72-dd94-4088-996a-6277c9e1fb74",
  publicId: "21",
  name: "Doors and windows",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01, task02, task03],
};

export default lesson;
